module.exports = __webpack_public_path__ + "static/media/screenshot7.b3c2f7e9.png";